// TODO: rename env variable to REACT_APP_API_URL
export const BASE_API_URL = process.env.REACT_APP_DEV_API_URL;
export const BASE_CONTENT_URL = process.env.REACT_APP_CONTENT_URL;
export const INTERCOM_API_KEY = process.env.REACT_APP_INTERCOM_API_KEY;
export const OLVY_ORGANISATION = process.env.REACT_APP_OLVY_ORGANISATION;
